import * as z$1 from "zod/v4";
//#region src/schemas/agent-profile-work-recovery.ts
const agentProfileWorkRecoveryActionKindSchema = z$1.enum([
	"continue_interrupted_work",
	"approve_queued_work",
	"skip_interrupted_work",
	"fork_interrupted_work"
]);
//#endregion
export { agentProfileWorkRecoveryActionKindSchema };

//# sourceMappingURL=agent-profile-work-recovery.js.map